<template>
  <b-button
      @click="() => { modalState = true }"
      size="sm"
      :disabled="disabled"
      :variant="(httpRequestInProgress) ? 'success': 'primary'"
      block
      v-show="!userPreferenceStore.coi.lightMode"
  ><!-- button -->
    <span v-if="httpRequestInProgress">
      <b-spinner
          type="grow"
          label="Loading..."
          small
      ></b-spinner>
      </span>
    <span v-else-if="customerOrder.deathCertificateCreatedAt != null">Totenschein: {{moment(customerOrder.deathCertificateCreatedAt).locale("de").format('L')}}</span>
    <span v-else>Totenschein ausstellen</span>
    <b-modal id="modal-unfreeze-order"
             v-model="modalState"
             title="Totenschein ausstellen"
             @ok="submit()"
             cancel-title="Abbrechen"
             size="md"
    ><!-- modal -->
      <p>Nur für den Verlust der Sendung auf dem Versandweg auszuwählen!</p>
      <p>Achtung: nicht für Sendungen die beschädigt oder falsch beim Kunden ankamen gedacht!!!</p>
    </b-modal>
  </b-button>
</template>

<script>
import { useUserPreferenceStore } from '../../stores/UserPreferenceStore';

export default {
  setup(){
    const userPreferenceStore = useUserPreferenceStore();
    return {userPreferenceStore}
  },
  name: "COIActionBarDeathCertificate",
  props: ['customerOrder','authorization'],
  data() {
    return {
      modalState: false,
      httpRequestInProgress: false
    };
  },
  modalState: false,
  httpRequestInProgress: false,
  computed: {
    disabled: function() {
      // TODO: is it needed to disable the function in some cases?
      return this.customerOrder.deathCertificateCreatedAt != null;
    }
  },
  methods: {
    submit() {
      this.httpRequestInProgress = true;

      let payload = {
        customerOrderId: this.customerOrder.id
      }

      Promise.all([
        axios.post('/customerorder/action/issue_death_certificate', payload),
        new Promise(r => setTimeout(r, 500))
      ]).then( response => {
        this.customerOrder.deathCertificateCreatedAt = moment().format("YYYY-MM-DD HH:mm:ss");
        this.httpRequestInProgress = false;
      }).catch( error => {
        alert(error.response.data)
        console.error(error);
        this.httpRequestInProgress = false;
      });
    }
  }
}
</script>